<template>
  <div class="html-page home-page">
    <main>
      <section class="hero" id="inicio" data-bloco="home-hero" data-tipo="hero" :style="bg(homeHero)">
        <div class="hero-grid container">
          <div class="hero-copy reveal">
            <p class="eyebrow" data-campo="iti_nome" v-html="html(homeHero, 'iti_nome')"></p>
            <h1 data-campo="iti_resumo1" v-html="html(homeHero, 'iti_resumo1')"></h1>
            <p data-campo="iti_descricao1" v-html="html(homeHero, 'iti_descricao1')"></p>
            <div class="hero-actions"><a class="btn btn-primary" data-campo="iti_textobtn1" data-link="iti_linkbtn1"
                v-html="html(homeHero, 'iti_texto_btn1')" :href="link(homeHero, 'iti_link_btn1')"></a><router-link
                to="/exames" class="btn btn-light" data-campo="iti_textobtn2" data-link="iti_linkbtn2"
                v-html="html(homeHero, 'iti_texto_btn2')" :href="link(homeHero, 'iti_link_btn2')"></router-link></div>
            <div class="hero-trust"><span data-campo="iti_descricao2"
                v-html="html(homeHero, 'iti_descricao2')"></span><span data-campo="iti_descricao3"
                v-html="html(homeHero, 'iti_descricao3')"></span></div>
          </div>
          <div class="hero-media reveal" data-bloco="home-slider" data-tipo="slider" :style="bg(homeSlider)">
            <div class="home-slider" data-repetidor="home-slider">
              <figure class="home-slide" :class="{ active: index === heroSlide }" data-item=""
                v-for="(item, index) in homeSlider" :key="index"><img alt="Tutora com seu cão" data-img="imagem"
                  :src="image(item)" v-if="image(item)" @error="hideBrokenImage">
                <figcaption><strong data-campo="iti_nome" v-html="html(item, 'iti_nome')"></strong><span
                    data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></span></figcaption>
              </figure><button v-if="homeSlider.length > 1" class="slider-arrow prev" type="button"
                aria-label="Imagem anterior" @click="previousHeroSlide">‹</button><button v-if="homeSlider.length > 1"
                class="slider-arrow next" type="button" aria-label="Próxima imagem" @click="nextHeroSlide">›</button>
              <div v-if="homeSlider.length > 1" class="slider-dots" aria-label="Navegação do slider"><button
                  v-for="(_, index) in homeSlider" :key="index" type="button" :class="{ active: index === heroSlide }"
                  :aria-label="'Mostrar imagem ' + (index + 1)" @click="goHeroSlide(index)"></button></div>
            </div>
          </div>
        </div>
      </section>
      <div class="feature-strip" data-bloco="home-diferenciais" data-tipo="lista" :style="bg(homeDiferenciais)">
        <div class="features container reveal" data-repetidor="home-diferenciais">
          <article class="feature" data-item="" v-for="(item, index) in homeDiferenciais" :key="index"><span
              class="icon"><img alt="" data-img="imagem" :src="image(item)" v-if="image(item)"
                @error="hideBrokenImage"></span>
            <h3 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h3>
            <p data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></p>
          </article>
        </div>
      </div>
      <section class="section" id="imaginar" data-bloco="home-a-imaginar" data-tipo="conteudo">
        <div class="split container">
          <div v-if="contentImages(homeAImaginar).length" class="image-stack reveal"><img
              v-if="contentImages(homeAImaginar)[0]" class="main" alt="Cão em atendimento com sua tutora"
              :src="contentImages(homeAImaginar)[0]" @error="hideBrokenImage"><img
              v-if="contentImages(homeAImaginar)[1]" class="mini" :src="contentImages(homeAImaginar)[1]"
              alt="Cão recebendo cuidado próximo" @error="hideBrokenImage"></div>
          <div class="split-copy reveal">
            <p class="eyebrow" data-campo="iti_nome" v-html="html(homeAImaginar, 'iti_nome')"></p>
            <h2 data-campo="iti_resumo1" v-html="html(homeAImaginar, 'iti_resumo1')"></h2>
            <p data-campo="iti_descricao1" v-html="html(homeAImaginar, 'iti_descricao1')"></p>
            <div class="checks"><span>Atendimento especializado</span><span>Estrutura preparada</span><span>Precisão
                diagnóstica</span><span>Cuidado individualizado</span></div><router-link to="/quem-somos"
              class="text-link" data-campo="iti_textobtn1" data-link="iti_linkbtn1"
              v-html="html(homeAImaginar, 'iti_texto_btn1')" :href="link(homeAImaginar, 'iti_link_btn1')"></router-link>
          </div>
        </div>
      </section>
      <section class="section soft" id="exames">
        <div class="container">
          <div class="section-head reveal" data-bloco="home-exames-titulo" data-tipo="conteudo">
            <div>
              <p class="eyebrow" data-campo="iti_nome" v-html="html(homeExamesTitulo, 'iti_nome')"></p>
              <h2 data-campo="iti_resumo1" v-html="html(homeExamesTitulo, 'iti_resumo1')"></h2>
            </div>
            <p data-campo="iti_descricao1" v-html="html(homeExamesTitulo, 'iti_descricao1')"></p>
          </div>
          <div class="service-grid" data-repetidor="exames-menu">
            <article class="service-card reveal" data-item="" v-for="(item, index) in examesMenu"
              :key="item.itiId || index">
              <div class="service-icon"><img alt="" data-img="icone" :src="icon(item)" v-if="icon(item)"
                  @error="hideBrokenImage"></div><router-link class="service-title-link" :to="examRoute(item)">
                <h3 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h3>
              </router-link>
              <p data-campo="iti_resumo1" v-html="html(item, 'iti_resumo1')"></p><router-link class="text-link"
                data-link="iti_linkbtn1" :to="examRoute(item)">Saiba mais →</router-link>
            </article>

          </div>
        </div>
      </section>
      <section class="tech" id="tomografia" data-bloco="home-exames-cta" data-tipo="conteudo">
        <div class="tech-grid">
          <div class="tech-copy reveal">
            <p class="eyebrow" data-campo="iti_descricao1" v-html="html(homeExamesCta, 'iti_descricao1')"></p>
            <h2 data-campo="iti_nome" v-html="html(homeExamesCta, 'iti_nome')"></h2>
            <p data-campo="iti_descricao2" v-html="html(homeExamesCta, 'iti_descricao2')"></p><a class="btn btn-light"
              data-campo="iti_textobtn1" data-link="iti_linkbtn1" v-html="html(homeExamesCta, 'iti_texto_btn1')"
              :href="link(homeExamesCta, 'iti_link_btn1')"></a>
          </div>
          <div class="tech-media"><img alt="Tomografia computadorizada veterinária" data-img="imagem"
              :src="image(homeExamesCta)" v-if="image(homeExamesCta)" @error="hideBrokenImage"></div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <div class="section-head reveal" data-bloco="home-como-funciona" data-tipo="conteudo">
            <div>
              <p class="eyebrow" data-campo="iti_nome" v-html="html(homeComoFunciona, 'iti_nome')"></p>
              <h2 data-campo="iti_descricao1" v-html="html(homeComoFunciona, 'iti_descricao1')"></h2>
            </div>
            <p data-campo="iti_descricao2" v-html="html(homeComoFunciona, 'iti_descricao2')"></p>
          </div>
          <div class="process" data-bloco="home-como-funciona-lista" data-tipo="lista"
            data-repetidor="home-como-funciona-lista">
            <article class="step reveal" v-for="(item, index) in homeComoFuncionaLista" :key="index"><b>{{ index + 1
                }}</b>
              <h3 data-campo="iti_nome" v-html="html(item, 'iti_nome')"></h3>
              <p data-campo="iti_descricao1" v-html="html(item, 'iti_descricao1')"></p>
            </article>
          </div>
        </div>
      </section>
      <section class="section pro" id="veterinarios" :style="bg(homeEspacoMedicos)">
        <div class="pro-grid container">
          <div class="pro-copy reveal" data-bloco="home-espaco-medicos" data-tipo="conteudo">
            <p class="eyebrow" data-campo="iti_nome" v-html="html(homeEspacoMedicos, 'iti_nome')"></p>
            <h2 data-campo="iti_descricao1" v-html="html(homeEspacoMedicos, 'iti_descricao1')"></h2>
            <p data-campo="iti_descricao2" v-html="html(homeEspacoMedicos, 'iti_descricao2')"></p>
            <div class="hero-actions"><a class="btn btn-primary" data-campo="iti_textobtn1" data-link="iti_linkbtn1"
                v-html="html(homeEspacoMedicos, 'iti_texto_btn1')"
                :href="link(homeEspacoMedicos, 'iti_link_btn1')"></a><a class="btn btn-light" data-campo="iti_textobtn2"
                data-link="iti_linkbtn2" v-html="html(homeEspacoMedicos, 'iti_texto_btn2')"
                :href="link(homeEspacoMedicos, 'iti_link_btn2')"></a></div>
          </div>
          <div class="pro-stats reveal" data-bloco="home-medicos-lista" data-tipo="lista"
            data-repetidor="home-medicos-lista">
            <div class="stat" data-item v-for="(item, index) in homeMedicosLista" :key="index"><strong
                data-campo="iti_referencia" v-html="html(item, 'iti_referencia')"></strong><span data-campo="iti_nome"
                v-html="html(item, 'iti_nome')"></span></div>
          </div>
        </div>
      </section>
      <section class="section" id="conteudos">
        <div class="container">
          <div class="section-head reveal">
            <div>
              <p class="eyebrow">Conteúdos</p>
              <h2>Informação para<br>cuidar melhor.</h2>
            </div><router-link class="text-link" to="/blog">Ver todos os conteúdos →</router-link>
          </div>
          <div class="cards-3">
            <article class="article reveal" v-for="(item, index) in homeBlog" :key="item.itiId || index"><router-link
                class="home-blog-image" :to="blogRoute(item)"><img v-if="image(item)" :src="image(item)"
                  :alt="plain(item, 'iti_nome')" @error="hideBrokenImage"></router-link>
              <div class="article-body"><span v-if="html(item, 'iti_campo_extra2')" class="tag"
                  v-html="html(item, 'iti_campo_extra2')"></span><router-link class="home-blog-title"
                  :to="blogRoute(item)">
                  <h3 v-html="html(item, 'iti_nome')"></h3>
                </router-link>
                <p v-html="html(item, 'iti_resumo1')"></p><router-link class="text-link" :to="blogRoute(item)">Ler
                  conteúdo →</router-link>
              </div>
            </article>
          </div>
        </div>
      </section>
    </main>
    <a class="whatsapp" :href="link(homeTopoContato, 'iti_link_btn1')"
      aria-label="Falar com a Imaginar pelo WhatsApp"><span class="whatsapp-label">Agendamentos e dúvidas?<br>Fale pelo
        WhatsApp</span><span aria-hidden="true"></span></a>
  </div>
</template>

<script>
import {
  contentValue,
  firstImage,
  imageByGallery,
  allImages,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
  plainText,
} from '@/services/contentApi';

export default {
  name: 'HomeView',
  data() {
    return {
      homeTopoContato: {},
      homeHero: {},
      examesMenu: [],
      homeSlider: [],
      homeDiferenciais: [],
      homeAImaginar: {},
      homeExamesTitulo: {},
      homeExamesCta: {},
      homeComoFunciona: {},
      homeComoFuncionaLista: [],
      homeEspacoMedicos: {},
      homeMedicosLista: [],
      homeBlog: [],
      rodapeChamada: {},
      rodapeInformacoes: {},
      homeRedes: {},
      heroSlide: 0,
      carouselSlide: 0,
      carouselTimer: null,
    };
  },
  created() {
    this.loadContent();
  },
  mounted() {
    this.carouselTimer = window.setInterval(() => {
      this.nextHeroSlide();
      this.nextCarouselSlide();
    }, 5500);
  },
  beforeUnmount() {
    if (this.carouselTimer) window.clearInterval(this.carouselTimer);
  },
  methods: {
    examRoute(item) {
      const id = item?.itiId ?? item?.iti_id ?? '';
      return { path: '/exames', query: id ? { exame: String(id) } : {} };
    },
    plain(source, field) {
      return plainText(contentValue(source, field));
    },
    blogRoute(item) {
      const id = item?.itiId ?? item?.iti_id ?? '';
      const slug = this.plain(item, 'iti_nome')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      return { name: 'BlogDetalhe', params: { id: String(id), slug } };
    },
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source) {
      return firstImage(source);
    },
    contentImages(source) {
      return allImages(source);
    },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    icon(source) {
      return imageByGallery(source, 'Icone');
    },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_descricao1') || contentValue(source, 'iti_resumo1'),
        image: firstImage(source) || firstImage(this.homeSlider[0]),
      });
    },
    nextHeroSlide() {
      const total = this.homeSlider.length;
      if (total > 1) this.heroSlide = (this.heroSlide + 1) % total;
    },
    previousHeroSlide() {
      const total = this.homeSlider.length;
      if (total > 1) this.heroSlide = (this.heroSlide - 1 + total) % total;
    },
    goHeroSlide(index) {
      this.heroSlide = index;
    },
    nextCarouselSlide() {
      const total = this.$el.querySelectorAll('[data-vue-carousel="content"] > [data-slide-index]').length || 1;
      this.carouselSlide = (this.carouselSlide + 1) % total;
    },
    goCarouselSlide(index) {
      this.carouselSlide = index;
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 1,
          key: "homeTopoContato",
          multi: false,
        },
        {
          ctiId: 2,
          key: "homeHero",
          multi: false,
        },
        {
          ctiId: 21,
          key: "examesMenu",
          multi: true,
        },
        {
          ctiId: 3,
          key: "homeSlider",
          multi: true,
        },
        {
          ctiId: 4,
          key: "homeDiferenciais",
          multi: true,
        },
        {
          ctiId: 5,
          key: "homeAImaginar",
          multi: false,
        },
        {
          ctiId: 6,
          key: "homeExamesTitulo",
          multi: false,
        },
        {
          ctiId: 7,
          key: "homeExamesCta",
          multi: false,
        },
        {
          ctiId: 8,
          key: "homeComoFunciona",
          multi: false,
        },
        {
          ctiId: 9,
          key: "homeComoFuncionaLista",
          multi: true,
        },
        {
          ctiId: 10,
          key: "homeEspacoMedicos",
          multi: false,
        },
        {
          ctiId: 11,
          key: "homeMedicosLista",
          multi: true,
        },
        {
          ctiId: 26,
          key: "homeBlog",
          multi: true,
        },
        {
          ctiId: 12,
          key: "rodapeChamada",
          multi: false,
        },
        {
          ctiId: 13,
          key: "rodapeInformacoes",
          multi: false,
        },
        {
          ctiId: 14,
          key: "homeRedes",
          multi: false,
        },
      ]);

      if (Array.isArray(data.homeBlog)) {
        data.homeBlog = [...data.homeBlog]
          .map((item) => ({ item, random: Math.random() }))
          .sort((a, b) => a.random - b.random)
          .slice(0, 3)
          .map(({ item }) => item);
      }

      const useful = (value) => value !== '' && value !== null && value !== undefined && value !== 'NULL' && (!Array.isArray(value) || value.length > 0);
      Object.entries(data).forEach(([key, value]) => {
        const current = this[key];
        if (Array.isArray(value)) {
          if (!value.length) return;
          this[key] = value.map((item, index) => {
            const fallback = Array.isArray(current) ? (current[index] || {}) : {};
            const filled = Object.fromEntries(Object.entries(item || {}).filter(([, fieldValue]) => useful(fieldValue)));
            return { ...fallback, ...filled };
          });
          if (key === 'homeSlider') this.heroSlide = 0;
          return;
        }
        if (value && typeof value === 'object') {
          const filled = Object.fromEntries(Object.entries(value).filter(([, fieldValue]) => useful(fieldValue)));
          this[key] = { ...(current || {}), ...filled };
        }
      });
      this.applyMeta(this.homeHero);
    },
  },
};
</script>

<style scoped>
.service-title-link {
  color: inherit;
}

.service-title-link:hover h3,
.service-title-link:focus-visible h3 {
  color: #825195;
}
</style>
